"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var equal_1 = __importDefault(require("ajv/dist/compile/equal"));

var SCALAR_TYPES = ["number", "integer", "string", "boolean", "null"];

function getDef() {
  return {
    keyword: "uniqueItemProperties",
    type: "array",
    schemaType: "array",
    compile: function compile(keys, parentSchema) {
      var scalar = getScalarKeys(keys, parentSchema);
      return function (data) {
        if (data.length <= 1) return true;

        for (var k = 0; k < keys.length; k++) {
          var key = keys[k];

          if (scalar[k]) {
            var hash = {};

            var _iterator = _createForOfIteratorHelper(data),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var x = _step.value;
                if (!x || typeof x != "object") continue;
                var p = x[key];
                if (p && typeof p == "object") continue;
                if (typeof p == "string") p = '"' + p;
                if (hash[p]) return false;
                hash[p] = true;
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          } else {
            for (var i = data.length; i--;) {
              var _x = data[i];
              if (!_x || typeof _x != "object") continue;

              for (var j = i; j--;) {
                var y = data[j];
                if (y && typeof y == "object" && equal_1.default(_x[key], y[key])) return false;
              }
            }
          }
        }

        return true;
      };
    },
    metaSchema: {
      type: "array",
      items: {
        type: "string"
      }
    }
  };
}

exports.default = getDef;

function getScalarKeys(keys, schema) {
  return keys.map(function (key) {
    var _a, _b, _c;

    var t = (_c = (_b = (_a = schema.items) === null || _a === void 0 ? void 0 : _a.properties) === null || _b === void 0 ? void 0 : _b[key]) === null || _c === void 0 ? void 0 : _c.type;
    return Array.isArray(t) ? !t.includes("object") && !t.includes("array") : SCALAR_TYPES.includes(t);
  });
}

module.exports = getDef;